const initials = "userStatement/";
export const UPDATE_USER_STATEMENT_REDUCER = `${initials}UPDATE_USER_STATEMENT_REDUCER`;